import React, { useState } from "react";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";
import AthleteLayout from "../common/AthleteLayout";
import { AthleteHeader } from "../common/AthleteHeader";
import API_URL from "../../api/API";
import mBanner from "../../images/mbanner.png";

export const AthleteMembership = () => {
  const { athlete } = useAthleteAuthContext();
  const [trainingType, setTrainingType] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const renderTrainingContent = () => {
    if (trainingType === "onsite") {
      return (
        <div className="mt-6">
          <h4 className="text-lg mb-2 text-black">Onsite Training</h4>
          <p className="text-black font-light text-base mb-4">
            When you train onsite at AMAX, you step into a performance
            environment built for serious athletes. Inside our 9,000 sq. ft.
            indoor facility, you’ll find group sessions led by hands–on coaches
            who break down every movement. Our full weight room is equipped with
            D1–level testing systems, giving you real data and real progress.
            And with a 100m straightaway track just outside, every workout
            connects strength, speed, and precision — the AMAX way.
          </p>
          <div className="aspect-video rounded-lg overflow-hidden relative bg-[#2A2A2A]">
            {/* Placeholder */}
            <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-[#2A2A2A] to-[#1A1A1A]">
              <div className="text-center">
                <div className="w-14 h-14 rounded-full border border-white/20 flex items-center justify-center mx-auto mb-3">
                  <div className="ml-1 border-l-[12px] border-l-white border-y-[8px] border-y-transparent" />
                </div>

                <p className="text-white/80 text-xs uppercase tracking-wide">
                  Facility Video Coming Soon
                </p>
              </div>
            </div>

            {/* Hidden video for future */}
            <video
              src="https://www.w3schools.com/html/mov_bbb.mp4"
              controls
              className="w-full h-full object-cover opacity-0 pointer-events-none"
            />
          </div>
        </div>
      );
    }

    if (trainingType === "online") {
      return (
        <div className="mt-6">
          <h4 className="text-lg mb-2 text-black">Remote Training</h4>
          <p className="text-black font-light text-base mb-4">
            AMAX Online Training gives you the same elite coaching experience —
            wherever you train. Each athlete is paired with a dedicated coach
            who checks in weekly to guide progress and make adjustments as you
            go. Both your speed and strength programs are custom–built around
            your goals, abilities, and schedule — never a cookie–cutter plan.
            Backed by data and performance tracking, our system keeps your
            training personal, measurable, and designed for long–term results.
          </p>
          <div className="aspect-video rounded-lg overflow-hidden relative bg-[#2A2A2A]">
  {/* Placeholder */}
  <div className="absolute inset-0 flex items-center justify-center bg-gradient-to-br from-[#2A2A2A] to-[#1A1A1A]">
    <div className="text-center">
      <div className="w-14 h-14 rounded-full border border-white/20 flex items-center justify-center mx-auto mb-3">
        <div className="ml-1 border-l-[12px] border-l-white border-y-[8px] border-y-transparent" />
      </div>

      <p className="text-white/80 text-xs uppercase tracking-wide">
        Online Training Video Coming Soon
      </p>
    </div>
  </div>

  {/* Hidden video for future */}
  <video
    src="https://www.w3schools.com/html/mov_bbb.mp4"
    controls
    className="w-full h-full object-cover opacity-0 pointer-events-none"
  />
</div>
        </div>
      );
    }

    return null;
  };

  const handleSendEnquiry = async () => {
    if (!trainingType) {
      setErrorMsg("Please select a training type.");
      setTimeout(() => setErrorMsg(""), 3000);
      return;
    }
    if (!message.trim()) {
      setErrorMsg("Please enter a message before sending.");
      setTimeout(() => setErrorMsg(""), 3000);
      return;
    }

    const finalMessage = `Training Type: ${trainingType.toUpperCase()}\n\n${message}`;
    const formData = new FormData();
    formData.append("sender_id", athlete.id);
    formData.append("message", finalMessage);
    formData.append("sender_type", "athlete");
    formData.append("receiver_type", "amax");
    formData.append("receiver_id", "amax");

    setSending(true);
    try {
      const res = await fetch(API_URL.SEND_ATHLETE_MESSAGE_TO_AMAX, {
        method: "POST",
        headers: { Authorization: `Bearer ${athlete.token}` },
        body: formData,
      });
      const data = await res.json();

      if (data.success) {
        setTrainingType("");
        setMessage("");
        setSuccessMsg("Your enquiry has been sent successfully!");
        setTimeout(() => setSuccessMsg(""), 3000);
      } else {
        setErrorMsg("Failed to send enquiry. Please try again.");
        setTimeout(() => setErrorMsg(""), 3000);
      }
    } catch (err) {
      console.error("Error sending enquiry:", err);
      setErrorMsg("An error occurred. Please try again later.");
      setTimeout(() => setErrorMsg(""), 3000);
    } finally {
      setSending(false);
    }
  };

  return (
    <AthleteLayout>
      <div className="h-full flex flex-col bg-white pt-5">
        <div className="flex-1 overflow-y-auto">
          <div className="bg-white w-full max-w-2xl px-5 mx-auto h-inherit pb-10">
            <h3 className="text-black text-2xl pb-5 w-full max-w-2xl mx-auto">
              Hello, {athlete.firstname}
            </h3>

            {/* Top Banner */}
            <div className="w-full max-w-2xl mx-auto mb-8">
              <div className="w-full rounded-2xl overflow-hidden">
                <img
                  src={mBanner}
                  alt="Membership Banner"
                  className="w-full h-auto object-cover"
                />
              </div>

              <div className="mt-6">
                <h2 className="text-2xl text-black mb-3">
                  Unlock Your Speed Potential.
                </h2>

                <p className="text-black font-light text-base leading-relaxed">
                  Every athlete starts here — choose your path and start
                  training with AMAX.
                  <br />
                  <br />
                  Our training programs are built to help you move faster,
                  perform stronger, and train smarter. Whether you're training
                  in person or online, AMAX gives you access to elite speed
                  systems used by top athletes.
                </p>
              </div>
            </div>

            <div className="w-full max-w-2xl mx-auto p-5 bg-smock rounded-2xl shadow-sm">
              <h3 className="text-xl text-black mb-4">Training Inquiry</h3>

              {/* Feedback messages */}
              {successMsg && (
                <div className="mb-3 p-3 bg-green-100 border border-green-400 text-green-800 rounded">
                  {successMsg}
                </div>
              )}
              {errorMsg && (
                <div className="mb-3 p-3 bg-red-100 border border-red-400 text-red-800 rounded">
                  {errorMsg}
                </div>
              )}

              {/* Radio Buttons */}
              <div className="flex flex-col sm:flex-row gap-4 mb-4">
                {/* Onsite */}
                <label className="flex items-center gap-3 cursor-pointer select-none">
                  <input
                    type="radio"
                    name="training"
                    value="onsite"
                    checked={trainingType === "onsite"}
                    onChange={(e) => setTrainingType(e.target.value)}
                    className="hidden peer"
                  />
                  <span
                    className="w-5 h-5 rounded-full border-2 border-gray-400 flex items-center justify-center
      peer-checked:border-black peer-checked:bg-black transition"
                  >
                    <span className="w-2.5 h-2.5 rounded-full bg-white scale-0 peer-checked:scale-100 transition" />
                  </span>
                  <span className="text-base text-black">Onsite Training</span>
                </label>

                {/* Online */}
                <label className="flex items-center gap-3 cursor-pointer select-none">
                  <input
                    type="radio"
                    name="training"
                    value="online"
                    checked={trainingType === "online"}
                    onChange={(e) => setTrainingType(e.target.value)}
                    className="hidden peer"
                  />
                  <span
                    className="w-5 h-5 rounded-full border-2 border-gray-400 flex items-center justify-center
      peer-checked:border-black peer-checked:bg-black transition"
                  >
                    <span className="w-2.5 h-2.5 rounded-full bg-white scale-0 peer-checked:scale-100 transition" />
                  </span>
                  <span className="text-base text-black">Remote Training</span>
                </label>
              </div>
              {/* Dynamic Section */}
              {renderTrainingContent()}

              {/* Message Box */}
              <div className="mt-6">
                <label className="block text-base font-medium text-black mb-2">
                  Message to Admin
                </label>
                <textarea
                  rows="4"
                  className="w-full border border-grayish rounded-lg p-3 text-black text-base focus:outline-none focus:ring-2 focus:ring-darkYellow placeholder:text-black resize-none"
                  placeholder="Type your message or inquiry here..."
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                />
              </div>

              {/* Submit Button */}
              <div className="mt-4 flex justify-end">
                <button
                  disabled={sending}
                  onClick={handleSendEnquiry}
                  className="p-3 xs:p-4 text-white text-base leading-none bg-black hover:bg-black/70 rounded-xl transition-all duration-300 disabled:bg-black/50"
                >
                  {sending ? "Sending..." : "Send Inquiry"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AthleteLayout>
  );
};
